<template>
    <Layout>
        <template v-slot:title>
            <h1>Quiz</h1>
            <div class="pt-2 text-red text-bold">Records found: {{ totalItems }}</div>
        </template>

        <template v-slot:content>
            <Loader v-if="isLoading"></Loader>
            <div class="mb-3">
                <button
                    @click="openQuizModal('quiz')"
                    class="btn btn-success mr-2 mb-2"
                    data-toggle="modal"
                    data-target="#create-quiz-modal"
                    type="button"
                >
                    <PlusIcon size="1.2x"></PlusIcon> New Quiz
                </button>
                <button
                    @click="openQuizModal('poll')"
                    class="btn btn-success mr-2 mb-2"
                    data-toggle="modal"
                    data-target="#create-quiz-modal"
                    type="button"
                >
                    <PlusIcon size="1.2x"></PlusIcon> New Poll
                </button>
                <!-- <router-link
                    class="btn btn-success mr-2 mb-2"
                    tag="a"
                    :to="{ name: 'quizzes.quiz.create', params: { type: 'quiz' }}"
                ><PlusIcon size="1.2x"></PlusIcon> New Quiz</router-link> -->
                <!-- <router-link
                    class="btn btn-success mr-2 mb-2"
                    tag="a"
                    :to="{name: 'quizzes.quiz.create', params: { type: 'poll' }}"
                ><PlusIcon size="1.2x"></PlusIcon> New Poll</router-link> -->
                <button
                    v-if="hasCheck"
                    @click.stop="deleteQuizzesHandler"
                    class="btn btn-danger mr-2 mb-2"
                    type="button"
                >
                    <Trash2Icon size="1.2x"></Trash2Icon> Delete Selected
                </button>
            </div>

            <div class="row mb-4">
                <div class="col-sm-6 col-md-4 col-xl-2 mb-2">
                    <select v-model="filterType" class="form-control">
                        <option value="">Filter by type</option>
                        <option value="poll">Poll</option>
                        <option value="quiz">Quiz</option>
                    </select>
                </div>
                <div class="col-sm-6 col-md-4 col-xl-2 mb-2 mb-md-0">
                    <TagSelect v-model="filterTag" :tag-list="tagList" @input="onFilterTagHandler" />
                </div>
                <div class="col-sm-6 col-md-4 col-xl-2 mb-2 mb-md-0">
                    <CountryUserSelect
                        v-model="filterCountry"
                        @input="onFilterCountryHandler"
                        :country-list="countries"
                    ></CountryUserSelect>
                </div>
                <div class="col-sm-6 col-md-4 col-xl-2 mb-2 mb-md-0">
                    <PropertySelect
                        v-model="filterProperty"
                        @select="onFilterPropertyHandler"
                        :property-list="propertyList"
                    />
                </div>
                <div class="col-sm-6 col-md-4 col-xl-2">
                    <form @submit.prevent="onSearch" class="input-group btn-inline">
                        <input
                            v-model="keyword"
                            name="table_search"
                            class="form-control float-right"
                            placeholder="Search"
                            type="text"
                        />

                        <div class="input-group-append">
                            <button type="submit" class="btn btn-default">
                                <f-icon icon="search" />
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <div v-if="list.length > 0">
                <div class="row">
                    <div class="col-12">
                        <div class="table-responsive tbq-table-responsive">
                            <table class="table tbq-table">
                                <thead>
                                    <tr>
                                        <th class="text-center">
                                            <SquareIcon
                                                v-if="!isCheckAll"
                                                @click="onCheckAllHandler"
                                                class="cursor-pointer"
                                                size="1.5x"
                                            ></SquareIcon>
                                            <CheckSquareIcon
                                                v-if="isCheckAll"
                                                @click="onCheckAllHandler"
                                                class="cursor-pointer text-success"
                                                size="1.5x"
                                            ></CheckSquareIcon>
                                        </th>
                                        <th>Image</th>
                                        <th>
                                            <SortLink sort-key="title">Title</SortLink>
                                        </th>
                                        <th>
                                            <SortLink sort-key="playing_counter">Playing count</SortLink>
                                        </th>
                                        <th>Tag</th>
                                        <th>
                                            <SortLink sort-key="is_pin_quiz">Pin</SortLink>
                                        </th>
                                        <th class="text-center">
                                            <SortLink sort-key="type">Type</SortLink>
                                        </th>
                                        <th class="text-center">
                                            <SortLink sort-key="active_question_count">Questions</SortLink>
                                        </th>
                                        <th class="text-center">Status</th>
                                        <th class="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in list" :key="index">
                                        <td class="thin-cell text-center align-middle" nowrap>
                                            <SquareIcon
                                                v-if="!item.isCheck"
                                                @click="onCheckHandler(item)"
                                                class="cursor-pointer"
                                                size="1.5x"
                                            ></SquareIcon>
                                            <CheckSquareIcon
                                                v-if="item.isCheck"
                                                @click="onCheckHandler(item)"
                                                class="cursor-pointer text-success"
                                                size="1.5x"
                                            ></CheckSquareIcon>
                                        </td>
                                        <td class="thin-cell text-center align-middle" nowrap>
                                            <router-link
                                                tag="a"
                                                :title="item.title"
                                                :to="{
                                                    name: 'quizzes.quiz.questions',
                                                    params: {
                                                        id: item._id.$oid
                                                    }
                                                }"
                                            >
                                                <div
                                                    class="bg-image"
                                                    :style="`background-image: url(${getQuizImage(item, true)})`"
                                                >
                                                    <i v-if="item.is_pin_quiz === 1" class="fas fa-thumbtack pin"></i>
                                                </div>
                                            </router-link>
                                        </td>
                                        <td class="align-middle" style="min-width: 200px; max-width: 250px">
                                            <router-link
                                                tag="a"
                                                :title="item.title"
                                                :to="{
                                                    name: 'quizzes.quiz.questions',
                                                    params: {
                                                        id: item._id.$oid
                                                    }
                                                }"
                                                class="text-bold"
                                            >
                                                {{ item.title }}
                                            </router-link>
                                            <span
                                                v-if="item.is_sponsor_quiz"
                                                v-tippy="{ placement: 'top' }"
                                                content="Sponsored Quiz"
                                            >
                                                <ZapIcon class="text-success ml-1 cursor-pointer" size="1.2x" />
                                            </span>
                                            <span
                                                v-if="item.is_sponsor_quiz && item.sponsor_setting"
                                                class="d-block italic text-sm"
                                            >
                                                {{ item.sponsor_setting.title || '' }}
                                            </span>
                                            <small class="d-block mb-0" v-if="item.language">
                                                Language: {{ onLanguage(item.language) }}
                                            </small>
                                        </td>
                                        <td class="align-middle text-center" style="min-width: 200px; max-width: 250px">
                                            <small class="d-block mb-0">{{ toNumber(item.playing_counter) }}</small>
                                        </td>
                                        <td class="align-middle thin-cell">
                                            <Tags :tags="item.tags_name" :limitItem="3"></Tags>
                                        </td>
                                        <td class="align-middle">
                                            <div class="custom-control custom-switch mb-2 mr-2">
                                                <input
                                                    @change="onChangePinQuiz(item)"
                                                    :checked="item.is_pin_quiz"
                                                    :id="`quiz-pin-${index}`"
                                                    class="custom-control-input"
                                                    type="checkbox"
                                                />
                                                <label class="custom-control-label" :for="`quiz-pin-${index}`"></label>
                                            </div>
                                        </td>
                                        <td class="align-middle text-center text-capitalize">
                                            <span
                                                :class="{
                                                    'bg-info': item.type === 'poll',
                                                    'bg-success': item.type === 'quiz',
                                                    'px-3 py-1 rounded-pill': true
                                                }"
                                            >
                                                {{ item.type }}
                                            </span>
                                        </td>
                                        <td class="thin-cell text-center align-middle" nowrap>
                                            {{ item.sumQuestion }}
                                        </td>
                                        <td class="text-center align-middle" nowrap>
                                            <span
                                                v-if="item.status"
                                                class="px-2 py-1 rounded-pill d-inline-block bg-success"
                                            >
                                                Active
                                            </span>
                                            <span
                                                v-if="!item.status"
                                                class="px-2 py-1 rounded-pill d-inline-block bg-secondary"
                                            >
                                                Inactive
                                            </span>
                                        </td>
                                        <td class="thin-cell text-center align-middle" nowrap>
                                            <!-- hide because not up to date -->
                                            <!-- <router-link
                                                tag="a"
                                                :to="{
                                                    name: 'quizzes.quiz.edit',
                                                    params: { id: item._id.$oid, type: item.type }
                                                }"
                                                class="cursor-pointer mr-3"
                                            >
                                                <EditIcon size="1.3x" class="text-info"></EditIcon>
                                            </router-link> -->
                                            <CopyIcon
                                                @click="setQuizId(item._id.$oid)"
                                                class="text-warning cursor-pointer mr-3"
                                                data-toggle="modal"
                                                data-target="#duplicate-quiz-modal"
                                                size="1.3x"
                                            ></CopyIcon>
                                            <!-- @click.stop="duplicateQuiz(item._id.$oid)" -->
                                            <Trash2Icon
                                                @click.stop="removeQuiz(item._id.$oid)"
                                                class="text-danger cursor-pointer"
                                                size="1.3x"
                                            ></Trash2Icon>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="col-12 my-3">
                        <Paginator
                            @change="onPageChange"
                            :current-page="currentPage"
                            :page-count="pageCount"
                            :total-items="totalItems"
                        />
                    </div>
                </div>
            </div>
            <EmptyList v-else :label="emptyLabel" />
            <QuizModal
                @close="quizModal = false"
                @submit="findMany"
                :id="'create-quiz-modal'"
                :quizId="'new'"
                :show="quizModal"
                :type="createType"
            />
            <DuplicateQuizModal
                @duplicate="duplicateQuiz($event)"
                id="duplicate-quiz-modal"
                ref="duplicateQuizModal"
            ></DuplicateQuizModal>
        </template>
    </Layout>
</template>

<script>
import helperMixin from '@/mixins/helper'
import quizListMixin from '@/mixins/quiz-list'
import Layout from '@/components/Layout'
import Loader from '@/components/Loader'
import EmptyList from '@/components/EmptyList'
import Url from '@/service/url'
import QuizModal from '@/components/quizzes/QuizModal'
import Paginator from '@/components/Paginator'
import Tags from '@/components/Tags'
import $ from 'jquery'
import {
    // EditIcon,
    Trash2Icon,
    CheckSquareIcon,
    SquareIcon,
    PlusIcon,
    ZapIcon,
    CopyIcon
} from 'vue-feather-icons'
import { mapGetters } from 'vuex'
import TagSelect from '@/components/TagSelect'
import SortLink from '@/components/SortLink'
import DuplicateQuizModal from '@/components/quizzes/DuplicateQuizModal'
import datalist from '../../../../../frontend/src/mixins/datalist'
import CountryUserSelect from '@/components/CountryUserSelect'
import PropertySelect from '@/components/PropertySelect'

export default {
    name: 'quiz-index',

    mixins: [helperMixin, datalist, quizListMixin],

    components: {
        Layout,
        Loader,
        EmptyList,
        Paginator,
        // EditIcon,
        Trash2Icon,
        CheckSquareIcon,
        SquareIcon,
        PlusIcon,
        Tags,
        TagSelect,
        SortLink,
        QuizModal,
        ZapIcon,
        CopyIcon,
        DuplicateQuizModal,
        CountryUserSelect,
        PropertySelect
    },

    computed: {
        ...mapGetters('tag', {
            tags: 'tags'
        })
    },

    async created() {
        this.isLoading = true
        await this.fetchTag()
        this.findManyCountry()

        setTimeout(() => {
            this.findMany()
        }, 500)
    },

    mounted() {
        this.modalInit()
    },

    data() {
        return {
            list: [],
            isLoading: false,
            keyword: '',
            filterType: '',
            filterTag: [],
            quizModal: false,

            currentPage: 1,
            pageCount: 0,
            totalItems: 0,

            emptyLabel: 'No data in list.',
            createType: 'quiz',

            isCheckAll: false,
            hasCheck: false,

            tagList: [],
            filterCountry: [],
            countries: [],
            filterProperty: [],
            propertyList: [
                {
                    label: 'Pin Quiz',
                    value: 'is_pin_quiz'
                },
                {
                    label: 'Auto Generate Quiz',
                    value: 'auto_generate'
                },
                {
                    label: 'Sponsor Quiz',
                    value: 'is_sponsor_quiz'
                }
            ]
        }
    },

    watch: {
        $route() {
            const url = new Url()

            this.selectedStatus = ''

            if (!url.getQuery()['tag']) {
                this.filterTag = []
            }

            if (!url.getQuery()['country']) {
                this.filterCountry = []
            }

            if (!url.getQuery()['property']) {
                this.filterProperty = []
            }

            this.findMany(url.buildQuery())
        },

        filterType() {
            this.onSearch()
        },

        tags(val) {
            let tags = val
            let newTags = []

            for (let x in tags) {
                newTags.push({
                    label: tags[x].name,
                    code: tags[x]._id.$oid,
                    type: tags[x].type
                })
            }

            this.tagList = newTags
        }
    },

    methods: {
        openQuizModal(type) {
            this.createType = type
            this.quizModal = true
        },

        async findMany() {
            const url = new Url()
            const query = url.buildQuery()
            const self = this

            self.isLoading = true

            await self.$store
                .dispatch('quiz/findMany', query)
                .then(res => {
                    const quiz = res.data.data
                    const newQuiz = quiz.data.map(item => {
                        item = {
                            ...item,
                            isCheck: false
                        }

                        return item
                    })

                    self.list = newQuiz

                    self.pageCount = quiz.page_count
                    self.totalItems = quiz.total
                    self.currentPage = parseFloat(quiz.current_page)
                    self.keyword = query.keyword
                    self.filterType = query.type ? query.type : ''
                    if (query.tag) {
                        self.filterTag = Array.isArray(query.tag) ? query.tag : [query.tag]
                    }

                    if (query.country) {
                        self.filterCountry = Array.isArray(query.country) ? query.country : [query.country]
                    }

                    if (query.property) {
                        self.filterProperty = Array.isArray(query.property) ? query.property : [query.property]
                    }

                    self.list.map(item => {
                        item.sumQuestion = item.active_question_count
                    })

                    if (self.keyword !== '' && self.list.length === 0) {
                        this.emptyLabel = `
                            <p class="text-center text-muted">Your search <b class="text-dark">"${this.keyword}"</b> did not match.</p>
                            <p class="text-center text-muted">Please, try another keyword</p>
                        `
                    }

                    self.isLoading = false
                })
                .catch(() => {
                    self.isLoading = false
                })
        },

        onSearch() {
            const url = new Url()
            let query = url.buildQuery({
                page: 1,
                keyword: this.keyword,
                type: this.filterType,
                tag: this.filterTag,
                country: this.filterCountry,
                property: this.filterProperty
            })

            this.$router.replace({
                name: this.$router.currentRoute.name,
                query: query
            })
        },

        onPageChange(page) {
            var url = new Url()

            this.$router.replace({
                name: this.$router.currentRoute.name,
                query: url.buildQuery({ page })
            })
        },

        onCheckAllHandler() {
            this.isCheckAll = !this.isCheckAll

            this.list.forEach(item => {
                item.isCheck = this.isCheckAll
            })

            this.hasCheck = this.isCheckAll
        },

        onCheckHandler(item) {
            let listLength = this.list.length
            let listCheckLength = []

            item.isCheck = !item.isCheck

            listCheckLength = this.list.filter(check => {
                return check.isCheck
            }).length

            if (listLength === listCheckLength) {
                this.isCheckAll = true
            }

            if (!item.isCheck) {
                this.isCheckAll = false
            }

            this.hasCheck = listCheckLength > 0
        },

        fetchTag() {
            this.$store.dispatch('tag/findAll', { type: 'quiz' })
        },

        removeQuiz(id) {
            const self = this
            this.$vueConfirm.confirm(
                {
                    message: `Are you sure?`,
                    button: {
                        no: 'No',
                        yes: 'Yes'
                    }
                },
                function (confirm) {
                    if (confirm == true) {
                        self.isLoading = true
                        self.$store
                            .dispatch('quiz/deleteQuiz', {
                                id: id
                            })
                            .then(() => {
                                self.isLoading = false
                                self.findMany()
                                window.shout.success('Delete quiz success.')
                            })
                            .catch(() => {
                                self.isLoading = false
                                window.shout.error('Something wrong!')
                            })
                    }
                }
            )
        },

        deleteQuizzesHandler() {
            const self = this
            const listCheck = self.list.filter(item => {
                return item.isCheck
            })

            const listCheckIds = listCheck.map(item => {
                return item._id.$oid
            })

            self.$vueConfirm.confirm(
                {
                    message: `Are you sure?`,
                    button: {
                        no: 'No',
                        yes: 'Yes'
                    }
                },
                function (confirm) {
                    if (confirm == true) {
                        self.isLoading = true
                        self.$store
                            .dispatch('quiz/deleteMany', {
                                ids: listCheckIds
                            })
                            .then(() => {
                                window.shout.success('Delete Quizzes Success')
                                self.findMany()
                                self.hasCheck = false
                                self.isLoading = false
                            })
                            .catch(() => {
                                self.isLoading = false
                            })
                    }
                }
            )
        },

        onFilterTagHandler() {
            this.onSearch()
        },

        onFilterCountryHandler(val) {
            this.filterCountry = val
            this.onSearch()
        },

        onFilterPropertyHandler(val) {
            this.filterProperty = val
            this.onSearch()
        },

        findManyCountry() {
            this.$store
                .dispatch('quiz/findManyCountry')
                .then(res => {
                    this.countries = res.data.data
                })
                .catch(() => {
                    window.shout.error('Countries not found')
                })
        },

        setQuizId(id) {
            this.$refs.duplicateQuizModal.setId(id)
        },

        async duplicateQuiz(data) {
            // data.quizId, data.translate

            let quiz = await this.$store.dispatch('quiz/findById', data.quizId)
            if (quiz.status === 200) {
                quiz = quiz.data.data

                delete quiz._id
                delete quiz.code
                delete quiz.created_at
                delete quiz.updated_at

                quiz.title = `${quiz.title.replace('(copy)', '')} (copy)`
                quiz.is_pin_quiz = 0
                quiz.is_sponsor_quiz = false
                quiz.playing_counter = 0
                quiz.show_in_front_page = false
                quiz.created_by = 'admin'
                quiz.status = false
                quiz.translate = data.translate
                quiz.duplicate = data.duplicate

                this.$nextTick(async () => {
                    const createQuiz = await this.$store.dispatch('quiz/create', quiz)
                    if (createQuiz.status === 201) {
                        this.findMany()
                        $(`#duplicate-quiz-modal`).modal('hide')

                        window.shout.success('Duplicate quiz success.')
                    } else {
                        window.shout.error('Something wrong!')
                        $(`#duplicate-quiz-modal`).modal('hide')
                    }
                })
            }
        },

        onLanguage(data) {
            let languages = this.languageList

            if (typeof data != 'undefined') {
                for (let index in languages) {
                    if (languages[index].code == data.toUpperCase()) {
                        return languages[index].name + ' (' + languages[index].code + ')'
                    }
                }
            }
        },

        async onChangePinQuiz(val) {
            this.isLoading = true
            let isPin = 0

            if (typeof val.is_pin_quiz == 'undefined') {
                val.is_pin_quiz = 1
            } else {
                val.is_pin_quiz = !val.is_pin_quiz
            }

            isPin = val.is_pin_quiz ? 1 : 0

            await this.updatePinQuiz(val._id.$oid, isPin)
            await this.findMany()
        }
    }
}
</script>

<style lang="scss" scoped>
.col-xl-2 {
    @media (min-width: 1600px) {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 20%;
        flex: 0 0 20%;
        max-width: 20%;
    }
    @media (min-width: 1200px) and (max-width: 1600px) {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 25%;
    }
}

.bg-image {
    width: 80px;
    height: 80px;
    border: 3px solid white;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 0.25rem;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
    position: relative;

    .pin {
        position: absolute;
        top: 4px;
        right: 4px;
        font-size: 1rem;
        transform: rotate(45deg);
        color: rgba(255, 193, 7, 1);
        text-shadow: 0 0 2px rgba(0, 0, 0, 0.3);
    }
}

.theme-dark-mode {
    .bg-image {
        border-color: var(--dark-theme-primary);
    }
}
</style>
